import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CityDetailsResponse } from '../models/city-details.model';
import { CityDetailsRepository } from '../repositories/city-details.repository';

export class GetCityDetailsUseCase
    implements UseCase<string, CityDetailsResponse>
{
    constructor(private readonly repository: CityDetailsRepository) {}

    execute(url: string): Observable<CityDetailsResponse> {
        return this.repository.getCityDetails(url);
    }
}
